module.exports = __webpack_public_path__ + "static/media/bg1.b093fcc1.png";